import { Box, Text } from '@lounge-fe/ui-kit'
import classNames from 'classnames'
import { HTMLAttributes, PropsWithChildren } from 'react'

type BasketAddonButtonProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>

export const BasketAddonButton: React.FC<BasketAddonButtonProps> = ({
  className,
  children,
}) => {
  return (
    <Box
      as="button"
      className={classNames(
        'inline-flex items-center justify-center gap-x-4 py-3 px-3 border border-r-0 border-border-default cursor-pointer',
        className,
      )}
    >
      {children}
    </Box>
  )
}
